import { EvaluatieDetailsDto } from "@/shared/types";

export const MIDDELEN_INZET_VALUES = ["NietBesteld", "BesteldNietIngezet", "Ingezet"] as const;

export type MiddelInzet = (typeof MIDDELEN_INZET_VALUES)[number];

export type EvaluatiePunt =
    | "bijsturingTreindienst"
    | "begeleidingOmreis"
    | "alternatiefVervoer"
    | "klantopvang"
    | "personeel"
    | "interneBeleving"
    | "voorgesteldeActiepunten"
    | "klantbeleving";

export type Evaluatie = {
    geenVsmToegedeeld: boolean;
    heeftKhrStatus: boolean;
    icDocLink?: string;
    ingezetteMiddelen: Partial<Record<"tvv" | "faciliteiten" | "vos", MiddelInzet>>;
    evaluatiePunten: Partial<Record<EvaluatiePunt, string>>;
    busInzet: Partial<Record<"transvision" | "deWit", string>>;
};

export const Evaluatie = {
    fromDto: (dto: EvaluatieDetailsDto): Evaluatie => {
        return {
            geenVsmToegedeeld: dto.geenVsmToegedeeld,
            heeftKhrStatus: dto.heeftKhrStatus,
            icDocLink: dto.icDocLink,
            evaluatiePunten: dto.evaluatiePunten,
            ingezetteMiddelen: dto.ingezetteMiddelen,
            busInzet: dto.busInzet,
        };
    },

    getEvaluatiePuntLabel: (punt: EvaluatiePunt): string => {
        switch (punt) {
            case "bijsturingTreindienst":
                return "Bijsturing treindienst";
            case "begeleidingOmreis":
                return "Begeleiding omreis";
            case "alternatiefVervoer":
                return "Alternatief vervoer";
            case "klantopvang":
                return "Klantopvang trein / station";
            case "personeel":
                return "Personeel";
            case "interneBeleving":
                return "Interne beleving";
            case "voorgesteldeActiepunten":
                return "Voorgestelde actiepunten";
            case "klantbeleving":
                return "Klantbeleving";
            default:
                return punt;
        }
    },
};
